/**
 * Wrap an out-of-range longitude back into [-180, 180). Google Maps returns unwrapped
 * longitudes (e.g. -257.1) once the map is panned across the antimeridian,
 * and our API rejects anything out of range. Wrapped values are rounded to
 * 3 decimals to drop the float noise the modulo math introduces.
 */
export function normalizeLongitude(lon) {
  const value = Number(lon);

  if (!Number.isFinite(value) || (value >= -180 && value <= 180)) return lon;

  const wrapped = ((value + 180) % 360 + 360) % 360 - 180;

  return Math.round(wrapped * 1000) / 1000;
}
